import { Modal } from "antd";
import { SaleStaffQueryParams, SaleStaffType } from "features/sale-staffs/type";
import api from "service/apiService";
import { ApiResponse } from "types";
import { translate } from "utils";

export const defaultParamSaleStaff: SaleStaffQueryParams = {
	skip: 0,
	take: 30,
	status: null,
};
const API_PATH = "/dashboard/sale-staffs";
export const getListSaleStaffs = async (
	query?: SaleStaffQueryParams,
): Promise<ApiResponse<SaleStaffType[]>> => {
	const { data: response } = await api.get<ApiResponse<SaleStaffType[]>>(
		API_PATH,
		query,
	);
	return response;
};
export const createSaleStaff = async (data: SaleStaffType) => {
	try {
		const newData = await api.post<ApiResponse<SaleStaffType>>(API_PATH, data);
		return newData.data?.data;
	} catch {}
};

export const updateSaleStaffApi = async (
	id: number | string,
	data: SaleStaffType,
) => {
	try {
		await api.put<SaleStaffType>(`${API_PATH}/${id}`, data);
	} catch {}
};

export const getSaleStaffDetail = (
	id: number | string,
): Promise<SaleStaffType> =>
	new Promise((resolve, reject) => {
		api
			.get<ApiResponse<SaleStaffType>>(`${API_PATH}/${id}`)
			.then(res => {
				resolve(res.data?.data);
			})
			.catch(err => reject(err));
	});

export type AssignMerchantData = {
	addMerchantIds?: number[];
	removeMerchantIds?: number[];
};

export const updateAssignMerchant = async (
	id: number | string,
	data: AssignMerchantData,
) => {
	try {
		const newData = await api.put<ApiResponse<SaleStaffType>>(
			`${API_PATH}/${id}/bulk-merchants`,
			data,
		);
		return newData.data?.data;
	} catch {}
};
export const showConFirmDisabled = (
	onOk: () => void,
	onCancel?: () => void,
) => {
	Modal.confirm({
		title: translate("Confirmation"),
		content: translate(
			"You can only disable when this staff no longer takes care of a merchant. Transfer the merchant to another staff or remove the merchant from the staff's list.",
		),
		onOk,
		onCancel,
	});
};
